import React, {Component} from 'react';
import { Form, InputWrapper } from 'form';

import ReactPhoneInput from 'react-telephone-input';
import flags from '../../../images/flags.png';

import {t} from 'l10n';
import {escape} from 'l10n/utils';

import { Link } from 'components/ReactRouterDomLocalized';
import SubmitWrapper from 'components/form/SubmitWrapper';

import paths from 'paths';

import {updateActivationEmail, requestActivationSms, activateUserByCode} from 'backend-helpers/member';
import {GET_CURRENT_USER} from "reducers/currentUser";
import {connect} from "react-redux";

import '../../../sass/react-tel-input.scss';

const TURNSTILE_SITEKEY = '0x4AAAAAACYQvImRXMQ5dwGT';
const CAPTCHA_POLL_MS = 100;
const CAPTCHA_MAX_ATTEMPTS = 100;


class ModalMenuConfirmRegistration extends Component {

    constructor(props) {
        super(props);

        this.state = {
            buttons: true,
            pending: false,
            formEmail: false,
            formPhone: false,
            formConfirm: true,
            email: props.email,
            phone: '',
            done: false,
            message: null,
            error: null,
            captchaToken: null
        };

        this.widgetId = null;
        this.captchaRef = null;
        this._captchaInterval = null;

        this.setCaptchaRef = this.setCaptchaRef.bind(this);
        this.changePhone = this.changePhone.bind(this);
        this.onSubmitFormEmail = this.onSubmitFormEmail.bind(this);
        this.onSubmitFormPhone = this.onSubmitFormPhone.bind(this);
        this.onSubmitFormActivateByCode = this.onSubmitFormActivateByCode.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        const { formEmail, formPhone } = this.state;

        const captchaFormOpened =
            (formEmail && !prevState.formEmail) ||
            (formPhone && !prevState.formPhone);

        const captchaFormClosed =
            !formEmail && !formPhone &&
            (prevState.formEmail || prevState.formPhone);

        if (captchaFormOpened) {
            this.destroyCaptcha();
            this.setState({ captchaToken: null });
            this.initCaptcha();
        } else if (captchaFormClosed) {
            this.destroyCaptcha();
            this.setState({ captchaToken: null });
        }
    }

    componentWillUnmount() {
        this.destroyCaptcha();
    }

    setCaptchaRef(el) {
        this.captchaRef = el;
    }

    initCaptcha() {
        if (typeof window === 'undefined') return;

        clearInterval(this._captchaInterval);

        let attempts = 0;

        this._captchaInterval = window.setInterval(() => {
            attempts += 1;

            if (this.captchaRef && window.turnstile) {
                clearInterval(this._captchaInterval);
                this._captchaInterval = null;

                this.widgetId = window.turnstile.render(this.captchaRef, {
                    sitekey: TURNSTILE_SITEKEY,
                    callback: (token) => {
                        this.setState({ captchaToken: token, error: null });
                    },
                    'expired-callback': () => {
                        this.setState({ captchaToken: null });
                    },
                    'error-callback': () => {
                        this.setState({ captchaToken: null });
                    }
                });
            } else if (attempts >= CAPTCHA_MAX_ATTEMPTS) {
                clearInterval(this._captchaInterval);
                this._captchaInterval = null;
                console.error(
                    'Turnstile: не удалось инициализировать капчу ' +
                    '(проверьте, что скрипт api.js подключён и ref существует)'
                );
            }
        }, CAPTCHA_POLL_MS);
    }

    destroyCaptcha() {
        if (typeof window === 'undefined') return;

        clearInterval(this._captchaInterval);
        this._captchaInterval = null;

        if (window.turnstile && this.widgetId !== null) {
            try {
                window.turnstile.remove(this.widgetId);
            } catch (e) {
            }
        }
        this.widgetId = null;
    }

    resetCaptcha() {
        if (typeof window === 'undefined') return;

        if (window.turnstile && this.widgetId !== null) {
            window.turnstile.reset(this.widgetId);
        }

        this.setState({ captchaToken: null });
    }

    onSubmitFormEmail(formData, setErrors) {
        if (!this.state.captchaToken) {
            this.setState({ error: t('Please confirm you are not a robot') });
            return;
        }

        this.setState({ pending: true, error: false });

        updateActivationEmail(formData).then(() => {
            this.setState({
                pending: false,
                formEmail: false,
                email: formData.email,
                formConfirm: true,
            });
        }).catch((error) => {
            this.resetCaptcha();
            this.setState({
                pending: false,
                error: error.messages || error.message
            });
        });
    }

    changePhone(phone) { this.setState({phone: phone}); }

    onSubmitFormPhone(formData, setErrors) {
        if (!this.state.captchaToken) {
            this.setState({ error: t('Please confirm you are not a robot') });
            return;
        }

        this.setState({ pending: true, error: false });

        requestActivationSms({
            phone: this.state.phone,
            captcha: this.state.captchaToken
        })
            .then(() => {
                this.setState({
                    pending: false,
                    formPhone: false,
                    formConfirm: true,
                });
            })
            .catch((error) => {
                this.resetCaptcha();
                this.setState({
                    pending: false,
                    error: (error && (error.messages || error.message)) || error
                });
            });
    }

    onSubmitFormActivateByCode(formData, setErrors) {
        let {dispatch} = this.props;

        this.setState({pending: true, error: false});

        activateUserByCode(formData).then((response) => {
            this.setState({
                pending: false,
                formConfirm: false,
                buttons: false,
                message: response.message,
                done: true
            });

            dispatch({type: GET_CURRENT_USER});

        }).catch((error) => {
            this.setState({
                pending: false,
                error: error
            });
        });
    }

    actionSendEmail() {
        const { formEmail } = this.state;

        this.setState({
                formPhone: false,
                formEmail: !formEmail,
                error: null
            },
            () => { if(this.emailChangeInput) this.emailChangeInput.focus(); }
        );
    }

    actionSendPhone() {
        const { formPhone } = this.state;

        this.setState({
            formEmail: false,
            formPhone: !formPhone,
            error: null
        });
    }

    render() {
        const {
            pending,
            buttons,
            formEmail,
            formPhone,
            formConfirm,
            done,
            message,
            error,
        } = this.state;

        let email = this.state.email ? this.state.email : (this.props.email ? this.props.email : "");

        return (
            <div className="confirm-registration">
                <p className="name">
                    <span>{t('Activation')}</span>
                    <Link to="/?login" className="header-button">{t('Log in')}</Link>
                </p>

                {!done ?
                    <div className="text-confirm-registration">
                        <p dangerouslySetInnerHTML={{__html:t("Please enter the activation code we sent to your email <span class=\"underline\">%1</span> or clicking the activation link from email message.", escape(email))}}/>
                        <p>{t('If you do not receive this email immediately, check your "spam" folder and mark this as "non-spam".')}</p>
                        <p
                            dangerouslySetInnerHTML={{
                                __html:
                                    t(
                                        "If you can not find this email, activate your account par SMS or %1 so that I manually activate your account.",
                                        <Link href={paths.contact.path} target="_blank">{t('contact me')}</Link>
                                    )
                            }}
                        />
                    </div>
                    : null}

                {done ? (
                    <div className="text-confirm-registration">
                        <p
                            dangerouslySetInnerHTML={{
                                __html: message
                            }}
                        />
                        <p>
                            <Link to="/">{t('You can start using BobTV')}</Link>
                        </p>
                    </div>
                ) : null }

                {buttons ? (
                    <div className="buttons">
                        <button className={formEmail ? 'active' : null} onClick={() => this.actionSendEmail()}>{t('Change email')}</button>
                        <button className={formPhone ? 'active' : null} onClick={() => this.actionSendPhone()}>{t('Send to phone')}</button>
                    </div>
                ) : null}

                {formEmail ? (
                    <Form onSubmit={this.onSubmitFormEmail}>
                        <div className="space-between">
                            <input
                                data-formfield={true}
                                name="email"
                                type="email"
                                placeholder="Email"
                                defaultValue={email}
                                ref={(input) => {
                                    this.emailChangeInput = input;
                                }}
                            />
                            <div ref={this.setCaptchaRef} style={{margin: '20px 0'}}/>
                        </div>
                        <div>
                            <SubmitWrapper className="btn-submit" value={t('Send')} pending={pending}/>
                        </div>
                    </Form>
                ) : null}

                {formPhone ? (
                    <Form onSubmit={this.onSubmitFormPhone}>
                        <div className="space-between">
                            <ReactPhoneInput
                                name="phone"
                                defaultCountry="fr"
                                flagsImagePath={flags}
                                onChange={e => this.changePhone(e)}
                            />

                            <div ref={this.setCaptchaRef} style={{margin: '20px 0'}}/>
                        </div>

                        <div>
                            <SubmitWrapper className="btn-submit" value={t('Send')} pending={pending}/>
                        </div>
                    </Form>
                ) : null}


                {!formEmail && !formPhone && !done ? (
                    <Form onSubmit={this.onSubmitFormActivateByCode}>
                        <div className="space-between">
                            <InputWrapper data-formfield={true} name="code" type="text" inputMode="numeric" autoComplete="one-time-code" placeholder="Code" maxLength="6" forceHtml/>
                        </div>
                        <div>
                            <SubmitWrapper className="btn-submit" value={t('Send')} pending={pending}/>
                        </div>
                    </Form>
                ) : null}

                {error ?
                    <div className="error-messages">
                        <p dangerouslySetInnerHTML={{
                            __html: error
                        }}
                        />
                    </div>
                    : null}

            </div>
        )
    }

}

export default connect(
    state => ({
        currentUser: state.currentUser
    }),
    null
)(ModalMenuConfirmRegistration);


// WEBPACK FOOTER //
// ./src/components/modals/ModalMenu/ModalMenuConfirmRegistration.js